// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/products/StockLevelLabel.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/products/StockLevelLabel.tsx");
  import.meta.hot.lastModified = "1731877523863.602";
}
// REMIX HMR END

import { useTranslation } from 'react-i18next';
export function StockLevelLabel({
  stockLevel
}) {
  _s();
  const {
    t
  } = useTranslation();
  let stockLevelLabel = '';
  let badgeClasses = 'bg-gray-100 text-gray-800';
  switch (stockLevel) {
    case 'IN_STOCK':
      stockLevelLabel = t('product.inStock');
      badgeClasses = 'bg-green-100 text-green-800';
      break;
    case 'OUT_OF_STOCK':
      stockLevelLabel = t('product.outOfStock');
      badgeClasses = 'bg-red-100 text-red-800';
      break;
    case 'LOW_STOCK':
      stockLevelLabel = t('product.lowStock');
      badgeClasses = 'bg-yellow-100 text-yellow-800';
      break;
  }
  return <span className={'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ' + badgeClasses}>
      {stockLevelLabel}
    </span>;
}
_s(StockLevelLabel, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, function () {
  return [useTranslation];
});
_c = StockLevelLabel;
var _c;
$RefreshReg$(_c, "StockLevelLabel");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;